<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加公告' : '修改公告'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
      >
        <el-form-item>
          <div>
            <el-tabs type="card" v-model="form.activeLanguageTabName">
              <el-tab-pane
                v-for="item in form.languageAnnouncements"
                :key="item.language"
                :name="item.language"
              >
                <span slot="label"><i v-if="item.title == ''" class="el-icon-info" style="margin-right: 5px"></i>{{`[${item.language}]`}}</span>
                <div>
                  <label style="display: block">{{
                    `[${item.language}] 标题：`
                  }}</label>
                  <el-input
                    v-model="item.title"
                  ></el-input>
                </div>
                <div style="margin-top: 5px">
                  <label style="display: block">{{
                    `[${item.language}] 正文：`
                  }}</label>
                  <el-input
                    type="textarea"
                    rows="15"
                    v-model="item.content"
                  ></el-input>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form-item>
        <el-form-item label="设定到时间才生效：">
          <el-switch v-model="form.showAtSwitch" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item label="生效时间：" v-if="form.showAtSwitch">
          <el-date-picker v-model="form.showAt" type="datetime"  :clearable="false"  placeholder="选择时间" format="yyyy-MM-dd HH:mm:ss"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="!this.value.isCreate">
          <div style="color: red;">注意：新添加的公告将会排在公告集合的最前面，可在完成添加之后手动重新调整排列顺序</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      languages: [], // 所有的语言
      form: {
        name: "",
        activeLanguageTabName: "",
        languageAnnouncements: [], // 各个语言对应的公告（标题和正文）
        showAtSwitch:false,
        showAt:0, // 对外显示时间
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  async created() {
    // 查询语言集合
    let languages = await bizutil.loadAvailableLanguages();

    if (this.value.isCreate) {
      // 为各个语言构建空内容
      await this.buildEmptyAnnouncementsForAllLanguages(languages);
    } else {
      this.form.languageAnnouncements = this.value.announcement.languageAnnouncements;
      if (languages && languages.length > 0) {
        this.form.activeLanguageTabName = languages[0];
      }

      this.form.showAt = this.value.announcement.showAt
      if(this.form.showAt != "0"){
        this.form.showAtSwitch = true
      }
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        let apiUrl = "";
        let requestBody = null;
        if (this.value.isCreate) {
          apiUrl = `${util.getBackendApiBase()}/v1/admin/addAnnouncement`;
          requestBody = {
            showAt:this.form.showAtSwitch?String(this.form.showAt):"0",
            languageAnnouncements: this.form.languageAnnouncements,
          };
        } else {
          apiUrl = `${util.getBackendApiBase()}/v1/admin/updateAnnouncement`;
          requestBody = {
            id: this.value.announcement.id,
            showAt:this.form.showAtSwitch?String(this.form.showAt):"0",
            languageAnnouncements: this.form.languageAnnouncements,
          };
        }

        let resData = (
          await axios.post(apiUrl, requestBody, {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          })
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },

    /**
     * 为各个语言构建空内容
     */
    async buildEmptyAnnouncementsForAllLanguages(languages) {
      for (let l of languages) {
        this.form.languageAnnouncements.push({
          language: l,
          title: "",
          content: "",
        });
      }

      if (
        this.form.languageAnnouncements &&
        this.form.languageAnnouncements.length > 0
      ) {
        this.form.activeLanguageTabName =
          this.form.languageAnnouncements[0].language;
      }

      this.form.showAtSwitch = false
      this.form.showAt = 0
    },
  },
};
</script>